import React from 'react'
import loader from './loader.gif'

const AppLoader = () => {
    return <img src={loader} alt='loader' width="200"/>
}

export default AppLoader